import { JobType } from '../../constants';
import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'automatedJobs/sequenceSplittingTable',
  url: '/api/jobs',
  filters: {
    type: JobType.SEQUENCE_SPLIT,
  },
  sortOrder: 'desc',
  orderBy: 'id',
});
